/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleMovementPeriod
 */
export interface VehicleMovementPeriod {
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementPeriod
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMovementPeriod
     */
    eventId: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementPeriod
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMovementPeriod
     */
    userId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleMovementPeriod
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleMovementPeriod
     */
    stopTime: Date;
}

/**
 * Check if a given object implements the VehicleMovementPeriod interface.
 */
export function instanceOfVehicleMovementPeriod(value: object): value is VehicleMovementPeriod {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('stopTime' in value) || value['stopTime'] === undefined) return false;
    return true;
}

export function VehicleMovementPeriodFromJSON(json: any): VehicleMovementPeriod {
    return VehicleMovementPeriodFromJSONTyped(json, false);
}

export function VehicleMovementPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMovementPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventId': json['eventId'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'startTime': (new Date(json['startTime'])),
        'stopTime': (new Date(json['stopTime'])),
    };
}

export function VehicleMovementPeriodToJSON(json: any): VehicleMovementPeriod {
    return VehicleMovementPeriodToJSONTyped(json, false);
}

export function VehicleMovementPeriodToJSONTyped(value?: VehicleMovementPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'eventId': value['eventId'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'startTime': value['startTime'].toISOString(),
        'stopTime': value['stopTime'].toISOString(),
    };
}

